export default "__VITE_ASSET__H2mtoj9___"